var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWinterwheelsVolumeUp = function SvgWinterwheelsVolumeUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .586v18.828L5.586 13H2C.9 13 .078 12.228.005 11.155L0 11V9c0-1.1.772-1.922 1.845-1.995L2 7h3.586L12 .586ZM13.5 3.9c3.352 0 6 2.648 6 6s-2.648 6-6 6v-2c2.248 0 4-1.752 4-4s-1.752-4-4-4ZM10 5.414 6.414 9H2v2h4.414L10 14.586V5.414ZM13.2 9.4v-2c1.352 0 2.5 1.148 2.5 2.5 0 1.298-1.058 2.408-2.339 2.495l-.161.005v-2c.248 0 .5-.252.5-.5 0-.22-.2-.444-.418-.491L13.2 9.4v-2Z"
  })));
};
export default SvgWinterwheelsVolumeUp;